import Product from '../routes/product/Product';
import Cabinet from '../routes/Cabinet';
import Order from '../routes/order/Order';
import Page from '../routes/Page';
import HomePage from '../routes/HomePage'
import PageAboutUs from '../routes/PageAboutUs'
import Delivery from '../routes/delivery/Delivery'
import News from '../routes/news/News'
import Contacts from '../routes/contacts/Contacts'
import Catalog from '../routes/catalog/Catalog'
import Basket from '../routes/basket/Basket'
import Login from '../routes/Login';


export const routes = [
	{
		path: '/',
		exact: true,
		component: HomePage
	},
	{
		path: '/about_us',
		exact: true,
		component: PageAboutUs
	},
	{
		path: '/delivery',
		exact: true,
		component: Delivery
	},
	{
		path: '/news',
		exact: true,
		component: News
	},
	{
		path: '/contacts',
		exact: true,
		component: Contacts
	},
	{
		path: '/catalog',
		exact: true,
		component: Catalog
	},
	{
		path: '/basket',
		exact: true,
		component: Basket
	},
	{
		path: '/products/:id',
		exact: true,
		component: Product
	},
	{
		path: '/order',
		exact: true,
		component: Order
	},
	{
		path: '/cabinet',
		exact: true,
		component: Cabinet
	},
	{
		path: '/page/:slug',
		exact: true,
		component: Page
	},
];

export const modals = [
	{
	    path: "/login",
	    template: 'blank',
	    notlogged:true,
	    component: Login
	},
];